import * as React from 'react'
import { Spacing, Container } from 'DVWebNodeUI'
import { withFatalCheck } from '../error/withFatalCheck'
import { Episode } from '../episode/episode'
import { StringId } from '../localizer/stringId'
import { CustomerErrorMessage } from '../customerErrorMessage/customerErrorMessage'
import { CollectionPagination } from '../collection/pagination'

import { tryCatch } from '../../utils/tryCatch'
import * as st from './episodeList.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import { ICollection } from '../../selectors/collections';

const EpisodeListValid = tryCatch(({ header, cardTitleIds, totalEpisodeSize, collectionType}: ICollection) => {
  if (!collectionType) {
    return null
  }

  const cardComponents =
    cardTitleIds.map((titleId, idx) => {
      const episodeProps = {
        titleId,
        collectionType,
        epListIndex: `${collectionType}-${idx}`,
        isFirstEpisode: idx === 0,
        isBonus: collectionType === "bonus"
      }
      return (
        <React.Fragment key={idx}>
          <Episode {...episodeProps} />
        </React.Fragment>
      )
    })

  if ((cardComponents || []).length === 0) {
    return null
  }

  const paginationArgs = {
    totalEpisodeSize: totalEpisodeSize || 0,
    collectionType,
  }

  return (
    <Container className={stUtility.pageSection}>
      { header &&
      <h1 className={Spacing.base}>{header} ({totalEpisodeSize})</h1>}
      <ol className={st.episodeList}>{cardComponents}</ol>
      <CollectionPagination {...paginationArgs} />
    </Container>
  )
}, <CustomerErrorMessage stringId={StringId.DV_DP_unavailable_episode_list_message} />)

export const EpisodeList = withFatalCheck(EpisodeListValid)
